<template>
  <!-- 安全运行 -->
  <div class="operation">

    <el-form class="bginput" label-width="8rem">
      <el-form-item label="当前安全状态">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-select v-model="set.getType" placeholder="请选择">
              <el-option label="手动录入" :value="0"></el-option>
              <el-option label="后台获取" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="formData.status" placeholder="请选择">
              <el-option label="优秀" :value="1"></el-option>
              <el-option label="良好" :value="2"></el-option>
              <el-option label="较差" :value="3"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>

      <el-form-item label="已安全运行天数">
        <el-row :gutter="0">
          <el-col :span="6">
            <el-select v-model="set.getType" placeholder="请选择">
              <el-option label="手动录入" :value="0"></el-option>
              <el-option label="后台获取" :value="1"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-input v-model="formData.workingNum" placeholder="请录入运行天数">
               <template slot="suffix">天</template>
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>

      <div style="margin-top: 2rem;">
        <el-button @click="save" type="primary" size="small">保存设置</el-button>
      </div>

    </el-form>

  </div>
</template>

<script>
import api from '@/apis/safety/operation'
export default {
  data() {
    return {
      set:{
        getType: 0,
      },
      formData: {
        status:1,//1 优秀 2 良好 3 较差
        workingNum: '',
      },
    }
  },
  mounted() {
    api
      .list({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            this.formData = res.data.list[0]
          }
        } else {
          this.$message.error(res.message)
        }
      })
  },
  methods: {
    save() {
      api.save(this.formData).then((res) => {
        if (res.code === 10000) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less">
.operation { padding-top: 10px;
  .el-form-item{
    margin-bottom:15px;
  }
}
</style>